/** @format */

import { ProductReviewDrawerType } from '@product-reviews/data-access';

export interface ReviewContentListAction {
	callback: <T>(args?: T) => void;
	title: string;
}

export interface ReviewContentListConfiguration {
	actions?: ReviewContentListAction[];
	callback?: <T>(args?: T) => void;
	subtitle?: string;
	title: string;
	type: ProductReviewDrawerType;
}

export enum RequiredSEOFields {
	ORIGINAL_PRODUCT_NAME = 'OriginalProductName',
	RATING = 'Rating',
	RATING_RANGE = 'RatingRange',
	REVIEW_TEXT = 'ReviewText',
	TITLE = 'Title',
	USER_NICK_NAME = 'UserNickname',
}
